module.exports = {
  "country": "GR",
  "artist": "Kalomira",
  "song": "Secret Combination",
  "year": "2008",
  "place": "3",
  "spotify": "4K97pvdLv1zmJy2bvYtEFG"
};